import { useSearchParams } from "react-router-dom";
import { FormShell, Field, useFormSubmit, Success } from "@/components/forms/FormShell";
import { Textarea } from "@/components/ui/textarea";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import api from "@/lib/api";

export default function FitmentAssistance() {
  const [params] = useSearchParams();
  const productPrefill = params.get("product") || "";
  const { loading, done, submit } = useFormSubmit("/fitment-request");
  const onSubmit = (e) => {
    e.preventDefault();
    const fd = new FormData(e.target);
    submit(Object.fromEntries(fd), api);
  };
  return (
    <FormShell
      kicker="Fitment assistance"
      title="Not certain about fitment?"
      description="Send us your vehicle information, VIN, and existing part number. Our team will review the available product data and help you identify the appropriate listing."
    >
      {done ? (
        <Success message="Our team will review your vehicle information and email you the appropriate listing options." />
      ) : (
        <form onSubmit={onSubmit} className="space-y-5" data-testid="fitment-form">
          <div className="grid md:grid-cols-2 gap-4">
            <Field label="Full name" name="name" required />
            <Field label="Email" name="email" type="email" required />
            <Field label="Phone" name="phone" />
            <Field label="Product URL" name="product_url" defaultValue={productPrefill.startsWith("http") ? productPrefill : ""} />
          </div>
          <div className="grid md:grid-cols-3 gap-4">
            <Field label="Year" name="year" />
            <Field label="Make" name="make" />
            <Field label="Model" name="model" />
            <Field label="Trim" name="trim" />
            <Field label="Engine size" name="engine" placeholder="e.g. 5.3L" />
            <Field label="Engine code" name="engine_code" />
            <Field label="VIN" name="vin" />
            <Field label="Original part number" name="original_part_number" />
            <Field label="Quantity needed" name="quantity_needed" />
          </div>
          <div>
            <Label className="text-[10px] font-mono uppercase tracking-widest text-slate-500">Notes</Label>
            <Textarea data-testid="field-notes" name="notes" rows={4} defaultValue={productPrefill && !productPrefill.startsWith("http") ? `Product of interest: ${productPrefill}` : ""} className="mt-1.5" placeholder="Anything else that will help us confirm fitment…" />
          </div>
          <p className="text-xs text-slate-500 border-l-2 border-slate-200 pl-3 py-1">
            InterCorp Industries can assist with product identification and listed compatibility. Mechanical diagnosis and installation should be completed by a qualified automotive professional.
          </p>
          <div className="pt-2">
            <Button type="submit" disabled={loading} className="bg-[#0055FF] hover:bg-[#0044CC] h-11 px-6" data-testid="fitment-submit">
              {loading ? "Sending…" : "Send fitment request"}
            </Button>
          </div>
        </form>
      )}
    </FormShell>
  );
}
